import { LocalStorageDataModel } from "@Constants/local-storage-data-model";
import { Env, getDataFromLocalStorage } from "@Src/utils/globalUtilities";
import axios from "axios";
const unauthorizedCode = [401];

export const DotNetBaseService = axios.create({
  timeout: 60000,
  baseURL: Env().REACT_APP_DOT_NET_BASE_URL,
});

DotNetBaseService.interceptors.request.use(
  (config: any) => {
    const token = localStorage.getItem("TaxmannAuthorization");
    let machineid = localStorage.getItem(LocalStorageDataModel.MACHINE_ID_NEW);

    config.headers = {
      refreshtoken: sessionStorage.getItem("refreshToken") || "",
      machineid: machineid,
    };

    if (token) {
      config.headers = {
        ...config.headers,
        taxmannauthorization: token,
      };
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

DotNetBaseService.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response } = error;
    if (response && unauthorizedCode.includes(response.status)) {
      // logoutUserSession()
    }
    return Promise.reject(error);
  }
);
